import { Box, Text, TextProps } from 'rebass';
import React from 'react';

type TimelineStatusCommentProps = TextProps & {
  comment: string | JSX.Element;
};

const TimelineStatusComment: React.FC<TimelineStatusCommentProps> = ({
  comment,
  ...props
}) => (
  <Box
    {...(props as any)}
    px={3}
    py={2}
    display="inline-block"
    sx={{ borderRadius: 'default' }}
    bg="white"
  >
    <Text variant="body2">{comment}</Text>
  </Box>
);

export default TimelineStatusComment;
